import axios from 'axios'

const namespaced = true

const state = {
  packageStatistic: null,
  totals: null,
  total: 0,
  isBusy: false,
  allDealersPackageStatistic: null
}

const actions = {
  getPackageStatistic ({ commit, state }, payload) {
    commit('setBusy', true)
    commit('setTotal')
    commit('setTotals')
    commit('setPackageStatistic')
    return new Promise((resolve, reject) => {
      const url = `/api/private/v3.0/billing/months/${payload.date.dateStart}/dealers/${payload.org_id}/reports/tracked-pairs-detail/`
      axios.get(url, { params: { month_end: payload.date.dateEnd } })
        .then(response => response.data)
        .then((res) => {
          commit('setBusy', false)
          commit('parsePackageStatistic', res)
          resolve('result')
        })
        .catch(error => {
          commit('setBusy', false)
          reject(error)
        })
    })
  },
  getPackageStatisticExcel ({ commit, state }, payload) {
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${payload.date.dateStart}/dealers/${payload.org_id}/reports/tracked-pairs-detail/xlsx/`,
      params: { id: payload.dealerId, month_end: payload.date.dateEnd }
    })
      .then((response) => {
        response.date = payload.date.dateString
        commit('downloadPackageStatistic', response)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setBusy', false)
      })
  },
  getPackageStatisticFilteredExcel ({ commit, state }, payload) {
    const data = {
      dealers_org_ids: payload.dealers,
      clients: payload.clients,
      month_end: payload.date.dateEnd
    }
    return axios({
      method: 'POST',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${payload.date.dateStart}/dealers/${payload.org_id}/reports/tracked-pairs-detail/xlsx/`,
      data
    })
      .then((response) => {
        response.date = payload.date.dateString
        commit('downloadPackageStatistic', response)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setBusy', false)
      })
  },
  getDetails ({ commit, state }, payload) {
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${payload.date.dateStart}/clients/${payload.org_id}/reports/dealer-detail-subreport/xlsx/`,
      params: { id: payload.dealerId, month_end: payload.date.dateEnd }
    })
      .then((response) => {
        response.name = payload.name
        response.date = payload.date.dateString
        commit('downloadDetails', response)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
      })
  }
}

const mutations = {
  parsePackageStatistic (state, value) {
    state.packageStatistic = value.data_clients
    state.totals = value.totals
    state.total = value.total
    state.allDealersPackageStatistic = value
  },
  downloadPackageStatistic (state, value) {
    const fileName = 'Статистика_по_пакетам_' + value.date + '.xlsx'
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const downloadBlob = new Blob([value.data], { type: value.headers['content-type'] })
      window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
    } else {
      try {
        const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['content-type'] })
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)
      } catch (error) {
        console.log(error)
      }
    }
  },
  downloadDetails (state, value) {
    const fileName = 'Детализация_' + value.name.replace(/[&/\\#, +()$~%.'":*?<>{}]/g, '_') + '_' + value.date + '.xlsx'
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const downloadBlob = new Blob([value.data], { type: value.headers['content-type'] })
      window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
    } else {
      try {
        const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['content-type'] })
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)
      } catch (error) {
        console.log(error)
      }
    }
  },
  setBusy (state, value) {
    state.isBusy = value
  },
  setTotal (state, value) {
    state.total = 0
  },
  setTotals (state, value) {
    state.totals = null
  },
  setPackageStatistic (state, value) {
    state.packageStatistic = null
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
